export default "__VITE_ASSET__CGEQMH_v__"